/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrderValidation,
  OrderValidationError,
  OrderValidationRequest,
} from '../models';
import {
    OrderValidationFromJSON,
    OrderValidationToJSON,
    OrderValidationErrorFromJSON,
    OrderValidationErrorToJSON,
    OrderValidationRequestFromJSON,
    OrderValidationRequestToJSON,
} from '../models';

export interface OrderVerifyCreateRequest {
    orderValidationRequest: OrderValidationRequest;
}

/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {

    /**
     * Check whether a purchased/trial license can be activated into a tenant
     */
    async orderVerifyCreateRaw(requestParameters: OrderVerifyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderValidation>> {
        if (requestParameters.orderValidationRequest === null || requestParameters.orderValidationRequest === undefined) {
            throw new runtime.RequiredError('orderValidationRequest','Required parameter requestParameters.orderValidationRequest was null or undefined when calling orderVerifyCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/order/verify/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderValidationRequestToJSON(requestParameters.orderValidationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderValidationFromJSON(jsonValue));
    }

    /**
     * Check whether a purchased/trial license can be activated into a tenant
     */
    async orderVerifyCreate(requestParameters: OrderVerifyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderValidation> {
        const response = await this.orderVerifyCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
